import React from 'react';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

interface SectionCardProps {
  id: string;
  icon: string;
  title: string;
  description: string;
  articleCount: number;
  href: string;
  featured?: boolean;
}

export default function SectionCard({
  icon,
  title,
  description,
  articleCount,
  href,
  featured = false,
}: SectionCardProps) {
  return (
    <Link href={href} className="block group">
      <div className={`card-luxury h-full p-6 flex flex-col gap-4 ${featured ? 'border-gold-subtle' : ''}`}>
        <div className="flex items-start justify-between">
          <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl flex-shrink-0 ${
            featured
              ? 'bg-gold-gradient' :'bg-surface-2 border border-border'
          }`}>
            {icon}
          </div>
          <span className="text-xs text-muted-foreground font-medium tabular-nums">
            {articleCount} article{articleCount !== 1 ? 's' : ''}
          </span>
        </div>
        <div className="flex-1">
          <h3 className={`font-serif text-lg font-semibold mb-2 transition-colors duration-200 ${
            featured ? 'text-gold' : 'text-foreground group-hover:text-gold'
          }`}>
            {title}
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed line-clamp-2">
            {description}
          </p>
        </div>
        <div className="flex items-center gap-1.5 text-sm font-medium text-gold opacity-0 group-hover:opacity-100 transition-all duration-200 translate-y-1 group-hover:translate-y-0">
          Browse articles
          <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </Link>
  );
}